import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(duration);
dayjs.extend(relativeTime);

export const formatDuration = (ms: number): string => {
  const dur = dayjs.duration(ms);
  if (dur.asSeconds() < 60) {
    return `${Math.round(dur.asSeconds())}s`;
  }
  if (dur.asMinutes() < 60) {
    return `${Math.round(dur.asMinutes())}m`;
  }
  return `${Math.round(dur.asHours())}h ${dur.minutes()}m`;
};

export const formatLastExecuted = (date?: string): string => {
  if (!date) return "Never";
  return dayjs(date).fromNow();
};

export const calculateSuccessRate = (
  successful: number,
  total: number
): string => {
  if (total === 0) return "0%";
  return `${Math.round((successful / total) * 100)}%`;
};

export const getWorkflowTypeLabel = (type: string): string => {
  const labels: Record<string, string> = {
    facebook_reply: "Facebook Reply",
    website_scraper: "Website Scraper",
    sheet_processor: "Sheet Processor"
  };
  return labels[type] || type;
};
